const tagList = () => import('@/pages/member/tag/index.vue');
const userList = () => import('@/pages/member/tag/user.vue');

export default [{
    path: '/member/tag',
    component: tagList,
    meta: [{
        name: '会员管理',
        activeRoute: '/member/manage'
    },
    {
        name: '标签列表',
		activeRoute: '/member/tag'
    }]
},{
    path: '/member/user',
    component: userList,
    meta: [{
        name: '会员管理',
		activeRoute: '/member/manage'
    },
    {
        name: '标签列表',
        url: '/member/tag'
    },
    {
        name: '关联用户列表',
        activeRoute: '/member/tag'
    }]
}];